export default __webpack_public_path__ + "static/media/equipment_character.c7520cd8.svg";